import { render, staticRenderFns } from "./RotaRoute.vue?vue&type=template&id=2531dfb8"
import script from "./RotaRoute.vue?vue&type=script&lang=js"
export * from "./RotaRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports